/* This file is auto-generated by 'tools/data-lib-gen'. Please don't edit it manually. */
import type { ArticleUserReaction } from '../models/ArticleUserReaction';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as request } from '../core/Request';
import type { RequestConfig } from '../core/Request';

export class ArticleUserReactionService {
  /**
   * Show user reaction
   * @returns article_user_reaction successful
   * @throws ApiError
   */
  public getAtreusArticlesUserReaction({
    articleSlug
  }: {
    /**
     * slug of article
     */
    articleSlug: string;
  }): CancelablePromise<ArticleUserReaction> {
    return request(this.config, {
      method: 'GET',
      url: '/kratos/atreus/articles/user_reaction/{article_slug}',
      path: {
        article_slug: articleSlug
      }
    });
  }

  constructor(private config?: RequestConfig) {}
}
